import { CREDENTIAL_KEY } from 'modules/credential/constants'
import { isInLengthRangeValidatorUtil } from 'modules/redux/validators/legacy'

const VALIDATOR = {
  [CREDENTIAL_KEY.NEW_PASSWORD]: isInLengthRangeValidatorUtil.bind(
    null, 'password'
  ),
  [CREDENTIAL_KEY.CONFIRM]: isInLengthRangeValidatorUtil.bind(
    null, 'password'
  )
}

function getValidatorCredentialUtil (key) {
  return VALIDATOR[key]
}

export {
  getValidatorCredentialUtil
}
